module.exports = __webpack_public_path__ + "static/media/ventilation_power_icon-color.5bf033a4.svg";